module.exports = {"pathContext":{"name":"DosageTreatmentType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CRI"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"MEDICATION"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-dosage-treatment-type.json
// module id = 1236
// module chunks = 237027443278143